import { render } from "./PendingProspectsWidget.vue?vue&type=template&id=7d1099ff&scoped=true"
import script from "./PendingProspectsWidget.vue?vue&type=script&lang=js"
export * from "./PendingProspectsWidget.vue?vue&type=script&lang=js"

import "./PendingProspectsWidget.vue?vue&type=style&index=0&id=7d1099ff&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1099ff"]])

export default __exports__